import { combineReducers } from "redux";
import bankAccountReducer from "./bank-account";
import lenderAccountReducer from "./lender-account";

export default combineReducers({
    bankAccounts: bankAccountReducer,
    lenderAccounts: lenderAccountReducer
});